import jsCookie from 'js-cookie'
import pickBy from 'lodash/pickBy'
import PropTypes from 'prop-types'
import qs from 'qs'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  customerUpdate,
  phaseChange,
  privacyUpdate,
  REGISTRATION_LEAD,
  registrationEmail,
  registrationLead,
  reroute,
  subscribeNewsletter,
} from '../../../actions/Buy'
import { setCodicePreventivo } from '../../../actions/buy/Ordini'
import verify from '../../../modules/verify'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import PhoneInput from '../../Input/Phone'
import DocumentiHelperModal from '../../noleggia/dumb/DocumentiHelperModal'
import triggerDataLayerEvent, {
  CRITEO_EVENTS,
  EVENT_TYPES,
  GA_EVENTS,
  PRODUCT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyButton from '../dumb/BuyButton'
import BuyCheckboxInput from '../dumb/BuyCheckboxInput'
import BuyTextInput from '../dumb/BuyTextInput'

function getUtmFromQs(qsObj) {
  const whitelist = [
    'gclid',
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content',
    'pk_campaign',
  ]

  return pickBy(qsObj, (v, k) => whitelist.includes(k))
}

class Register extends Component {
  constructor(props) {
    super(props)
    this.state = {
      phonePrefix: '+39',
    }
    this.state.toTop = false
    this.state.modal = false
    this.state.name_error = ''
    this.state.surname_error = ''
    this.state.email_error = ''
    this.state.phone_error = ''
    this.state.consenso_obbligatorio_privacy_brumbrum_error = ''
    this.state.show_newsletter_modal = false
    this.state.show_cppb_modal = false
    this.state.show_tdu_modal = false
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handlePrenota = this.handlePrenota.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)

    this.state.showPrenota = props.showPrenota

    this.formRef = null
  }

  componentDidMount() {
    // BRUM-9979 se presenti
    // si leggono dati sensibili da hash querystring
    if (
      this.props.routing &&
      this.props.routing.locationBeforeTransitions &&
      this.props.routing.locationBeforeTransitions.query
    ) {
      const { query } = this.props.routing.locationBeforeTransitions
      this.props.customerUpdate({
        nome: query.nome,
        cognome: query.cognome,
        email: query.email,
        phone: query.phone,
      })
    }

    this.props.phaseChange({ phase: 0 })

    if (window.location.search) {
      const p = qs.parse(window.location.search.substring(1))
      this.props.setCodicePreventivo(p.codice_preventivo)
    }
  }

  componentDidUpdate() {
    if (this.props.product.id_auto) {
      if (window.location.search) {
        const p = qs.parse(window.location.search.substring(1))
        // BRUM-8220 se ho id_lead vado direttamente al carrello
        // perche' provengo da stripe
        const { id_lead } = p
        if (id_lead) {
          /**
           * TS-1703
           * per supportare anche i link delle mail
           * di conferma blocco auto
           */
          this.props.customerUpdate({
            registration_lead: true,
            nome: p.nome,
            cognome: p.cognome,
            email: p.email,
          })
          // se poi e' presente anche il cookie
          // i dati del customer saranno sovrascritti

          if (jsCookie.get('auto_prenotata')) {
            // BRUM-9464 www2 setta questo cookie con i dati
            // sensibili dell'utente
            const autoPrenotataCustomerDetail =
              jsCookie.getJSON('auto_prenotata')
            if (typeof autoPrenotataCustomerDetail === 'object') {
              this.props.customerUpdate({
                registration_lead: true,
                nome: autoPrenotataCustomerDetail.nome,
                cognome: autoPrenotataCustomerDetail.cognome,
                email: autoPrenotataCustomerDetail.email,
              })
            }
          }

          this.props.setIdLead(id_lead)
          this.props.reroute(this.props.next)
        }
      }
    }
  }

  handleInput(label) {
    const t = this
    return event => {
      const v = t.validate(label, event.target.value)
      t.props.customerUpdate({
        [label]: v.value,
      })
    }
  }

  validateAll() {
    const t = this
    const validationMap = {
      name: t.props.customer.name || '',
      surname: t.props.customer.surname || '',
      email: t.props.customer.email,
      phone: t.props.customer.phone || '',
      consenso_obbligatorio_privacy_brumbrum:
        t.props.privacy.consenso_obbligatorio_privacy_brumbrum,
    }

    const validationResults = Object.keys(validationMap).map(key => {
      const isValid = t.validate(key, validationMap[key], true).is_valid
      return isValid
    })
    return validationResults.indexOf(false) === -1
  }

  validate(label, value, requireAttention = false) {
    const v = verify(label, value)
    const newState = {}

    if (v.is_required || !v.is_valid) {
      newState[`${label}_error`] = v.is_required
        ? `is-required is-${label}-required`
        : `is-error is-${label}-error`
    } else {
      newState[`${label}_error`] = ' is-ok'
    }

    this.setState(newState, () => {
      if (
        requireAttention &&
        document.querySelectorAll('.is-error, .is-required').length > 0
      ) {
        animateScroll.scrollTo(
          document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
            95,
          {
            smooth: true,
            dynamic: true,
          }
        )
      }
    })

    if (label === 'email' && v.is_valid) {
      this.props.registrationEmail({
        new: value,
        old: this.props.customer.registration_email,
      })
    }

    return v
  }

  handleCheckbox(label) {
    const t = this
    return event => {
      const v = t.validate(label, event.target.checked)
      t.props.privacyUpdate({
        [label]: v.value,
      })
    }
  }

  handlePrenota(e) {
    this.handleSubmit(e, true)
  }

  handleSubmit(e, isPrenota = false) {
    const t = this

    if (!this.props.fetching && t.validateAll()) {
      t.props.customerUpdate({
        nome: this.props.customer.nome || this.props.customer.name,
        cognome: this.props.customer.cognome || this.props.customer.surname,
      })

      const leadId = isPrenota ? 'registrazione_prenotazione' : t.props.idLead
      const { email } = t.props.customer

      const registrationLeadPayload = {
        accesstime: window.Cookies ? window.Cookies.get('accesstime') : null,
        accesstime_session: this.props.customer.access_time_session,
        email,
        id_auto: this.props.product.id_auto,
        lead: leadId,
        privacy: 'ok',
        cookiebot: window.Cookiebot ? window.Cookiebot.consent : {},
        utmfollower: getUtmFromQs(qs.parse(window.location.search)),
        referrer: typeof document !== 'undefined' ? document.referrer : null,
        url: window.location.href,
        pageType: this.props.ui.settings.pageType,
        pagina_destinazione_sessione: window.location.href.split(
          window.location.origin
        )[1],
        path_destinazione_sessione: window.location.pathname,
        productType: this.props.ui.settings.productType,
        referrer_follower: {
          access_time: window.Cookies
            ? window.Cookies.get('accesstime_referrer')
            : null,
          session: document.referrer,
          standard: undefined,
        },
        meta: {
          html: this.formRef.outerHTML,
        },
        consensi: [
          {
            accettato: 1,
            tipo_consenso: 'privacy_policy',
            versione: 5,
          },
        ],
      }

      const nome = t.props.customer.name
      if (t.props.customer.name !== null && t.props.customer.name.length > 0) {
        registrationLeadPayload.nome = nome
      }

      const cognome = t.props.customer.surname
      if (
        t.props.customer.surname !== null &&
        t.props.customer.surname.length > 0
      ) {
        registrationLeadPayload.cognome = cognome
      }

      const cellulare = t.props.customer.phone
      if (
        t.props.customer.phone !== null &&
        t.props.customer.phone.length > 0
      ) {
        registrationLeadPayload.telefono = cellulare
      }

      const idAuto = t.props.product.id_auto
      const qsStripe = {
        id_lead: t.props.ordine.id_evento
          ? t.props.ordine.id_evento
          : undefined,
        email: email || undefined,
        cellulare: cellulare || undefined,
        nome: nome || undefined,
        cognome: cognome || undefined,
        codice_preventivo: t.props.ordine.codice_preventivo
          ? t.props.ordine.codice_preventivo
          : undefined,
      }
      qsStripe.v = `${qsStripe.id_lead}_${new Date().getTime()}`

      if (this.props.customer.registration_lead) {
        // lead gia' registrato, si fa reroute diretto
        if (!isPrenota) {
          t.props.reroute(this.props.next)
        } else {
          window.location.href = `${
            window.location.origin
          }/prenota/${idAuto}?${qs.stringify(qsStripe)}`
        }
      } else {
        registrationLeadPayload.newsletter = 'ko'
        if (t.props.privacy.newsletter) {
          registrationLeadPayload.newsletter = 'ok'
          registrationLeadPayload.consensi.push(
            {
              accettato: 1,
              tipo_consenso: 'newsletter_commerciale',
              versione: 4,
            },
            {
              accettato: 1,
              tipo_consenso: 'sms',
              versione: 4,
            },
            {
              accettato: 1,
              tipo_consenso: 'newsletter_blog',
              versione: 4,
            }
          )
        }

        const sessionData =
          window && typeof window.sessionData === 'function'
            ? window.sessionData()
            : {}

        t.props
          .registrationLead({
            method: 'POST',
            uri: `${window.brumbrum.url_api}/lead/p/v3/${leadId}`,
            body: JSON.stringify({
              ...registrationLeadPayload,
              ...sessionData,
            }),
            callback: REGISTRATION_LEAD,
          })
          .then(json => {
            triggerDataLayerEvent(
              isPrenota
                ? GA_EVENTS.leadSelloutPrenota
                : t.props.GA_registerEvent,
              'event',
              {
                id_evento: json.result.id_evento,
                sorgente_lead: leadId,
                id: idAuto,
              }
            )

            triggerClickStreamEvent(
              CRITEO_EVENTS.TRANSACTION,
              EVENT_TYPES.CRITEO,
              {
                email: t.props.customer.email,
                idAuto: t.props.product.id_auto,
                transactionId: `${json.result.id_evento}_registrazione_acquisto`,
                productType: PRODUCT_TYPES.REGISTER,
                lead_name: GA_EVENTS.REGISTER,
              }
            )

            t.props.customerUpdate({
              registration_lead: true,
            })

            if (t.props.privacy.newsletter) {
              t.props.customerUpdate({
                newsletter_lead: true,
              })
            }

            fbPixel(FB_EVENTS.Lead, t.props.product)
            fbPixel(FB_EVENTS.InitiateCheckout, t.props.product)

            if (!isPrenota) {
              t.props.reroute(this.props.next)
            } else {
              const savedIdLead = json.result.id_evento
              qsStripe.id_lead = savedIdLead
              qsStripe.v = `${savedIdLead}_${new Date().getTime()}`

              window.location.href = `${
                window.location.origin
              }/prenota/${idAuto}?${qs.stringify(qsStripe)}`
            }
          })
          .catch(() => null)
      }
    }
  }

  render() {
    const p = qs.parse(window.location.search.substring(1))
    const backHref = p.v
      ? `${this.props.product.url}?v=${p.v}`
      : this.props.product.url

    return (
      <section className={'prenota-auto'}>
        <div className={'container_small'}>
          {this.props.ordine.codice_preventivo ? (
            <h3 style={{ textAlign: 'center' }}>
              Stai utilizzando il codice preventivo{' '}
              <b>{this.props.ordine.codice_preventivo}</b>
            </h3>
          ) : null}
          <form
            className={'form-prenotazione'}
            ref={form => (this.formRef = form)}
          >
            <span className={'payment-errors'}></span>
            <div className={'BuyHelpAnagrafica-wrapper'}>
              {this.state.showPrenota ? (
                <div
                  className={'BuyHelpAnagrafica only-desktop'}
                  id={'BuyHelpAnagrafica'}
                  style={{ marginTop: '100px' }}
                >
                  <p className={'text-center'}>
                    <b style={{ fontWeight: 400 }}>
                      Cosa è la Prenotazione rapida?
                    </b>
                  </p>
                  <p
                    className={'text-center'}
                    style={{ fontWeight: 300, fontSize: '12px' }}
                  >
                    Versando un <b>acconto di € 250</b> (completamente
                    rimborsabile) con carta di credito, l'auto risulterà da
                    subito <b>"Prenotata" in esclusiva per te</b> e avrai 48h
                    per completare l'acquisto.
                  </p>
                </div>
              ) : null}
            </div>

            <ul className={'data-form x-small registrazione-form'}>
              <li className={`wide ${this.state.name_error}`}>
                <BuyTextInput
                  classes={'input-data form-input big capitalize'}
                  dataCy={'registration-name'}
                  defaultValue={this.props.customer.name}
                  label={'Nome'}
                  name={'name'}
                  placeholder={'Scrivi il tuo Nome'}
                  type={'text'}
                  update={this.handleInput('name')}
                />
              </li>
              <li className={`wide ${this.state.surname_error}`}>
                <BuyTextInput
                  classes={'input-data form-input big capitalize'}
                  dataCy={'registration-surname'}
                  defaultValue={this.props.customer.surname}
                  label={'Cognome'}
                  name={'surname'}
                  placeholder={'Scrivi il tuo Cognome'}
                  type={'text'}
                  update={this.handleInput('surname')}
                />
              </li>
              <li className={`wide ${this.state.email_error}`}>
                <BuyTextInput
                  classes={'input-data form-input big'}
                  dataCy={'registration-email'}
                  defaultValue={this.props.customer.email}
                  label={'La tua email'}
                  name={'email'}
                  placeholder={'es: mario.rossi@gmail.com'}
                  type={'email'}
                  update={this.handleInput('email')}
                />
              </li>

              <li className={`wide ${this.state.phone_error}`}>
                <PhoneInput
                  className="input-data"
                  dataCy={'registration-phone'}
                  label="Il tuo telefono"
                  name={'phone'}
                  onChange={this.handleInput('phone')}
                  placeholder={'Scrivi il tuo Numero di cellulare'}
                  value={this.props.customer.phone}
                />
              </li>

              <li
                className={`wide ${this.state.consenso_obbligatorio_privacy_brumbrum_error}`}
              >
                <BuyCheckboxInput
                  checked={
                    this.props.privacy.consenso_obbligatorio_privacy_brumbrum
                  }
                  classes={'r-checkbox no-mar long'}
                  dataCy={'registration-privacy'}
                  href="http://design.brumbrum.it/privacy-policy-e-cookies"
                  label={[
                    'Ho preso visione e accetto la ',
                    <a
                      className={'modal-btn'}
                      data-modal={'condizioni-vendita'}
                      key={'link'}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.setState({ show_cppb_modal: true })
                      }}
                    >
                      Privacy Policy
                    </a>,
                    ' e i ',
                    <a
                      className={'modal-btn'}
                      data-modal={'condizioni-vendita'}
                      key={'link2'}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.setState({ show_tdu_modal: true })
                      }}
                    >
                      Termini di Utilizzo
                    </a>,
                    ' del sito web brumbrum.it',
                  ]}
                  name="privacy"
                  update={this.handleCheckbox(
                    'consenso_obbligatorio_privacy_brumbrum'
                  )}
                />
              </li>
              <li className={'wide'}>
                <BuyCheckboxInput
                  checked={this.props.privacy.newsletter}
                  classes={'r-checkbox no-mar'}
                  dataCy={'registration-newsletter'}
                  label={[
                    'Iscrivimi alla ',
                    <a
                      className={'modal-btn'}
                      key={'link'}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.setState({ show_newsletter_modal: true })
                      }}
                    >
                      newsletter brumbrum
                    </a>,
                  ]}
                  name="newsletter"
                  update={this.handleCheckbox('newsletter')}
                />
              </li>

              {this.state.showPrenota ? (
                <li className={'wide buttons'}>
                  <BuyButton
                    classes={`btn btn-primary${
                      this.props.fetching ? ' btn-disabled' : ''
                    }`}
                    label={'Procedi con la prenotazione rapida'}
                    update={this.handlePrenota}
                  />
                </li>
              ) : null}
              <li className={'wide buttons'}>
                <BuyButton
                  classes={
                    this.state.showPrenota
                      ? `btn btn-secondary${
                          this.props.fetching ? ' btn-disabled' : ''
                        }`
                      : `btn btn-primary${
                          this.props.fetching ? ' btn-disabled' : ''
                        }`
                  }
                  dataCy="registration-submit"
                  label={
                    this.state.showPrenota ? "Procedi all'acquisto" : 'Procedi'
                  }
                  update={this.handleSubmit}
                />
              </li>
              <li className={'wide buttons'}>
                {this.state.showPrenota ? (
                  <div
                    className={'BuyHelpAnagrafica only-mobile'}
                    id={'BuyHelpAnagrafica'}
                    style={{ float: 'none', margin: '10px auto' }}
                  >
                    <p className={'text-center'}>
                      <b style={{ fontWeight: 400 }}>
                        Cosa è la Prenotazione rapida?
                      </b>
                    </p>
                    <p
                      className={'text-center'}
                      style={{ fontWeight: 300, fontSize: '12px' }}
                    >
                      Versando un <b>acconto di € 250</b> (completamente
                      rimborsabile) con carta di credito, l'auto risulterà da
                      subito <b>"Prenotata" in esclusiva per te</b> e avrai 48h
                      per completare l'acquisto.
                    </p>
                  </div>
                ) : null}
                <a className="btn btn-back" href={backHref}>
                  Indietro
                </a>
              </li>
            </ul>
          </form>
        </div>

        <DocumentiHelperModal
          display={this.state.show_newsletter_modal}
          iframeSrc={`${window.location.origin}/privacy-newsletter/v4?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`}
          modalTitle="Informativa Privacy Newsletter brumbrum"
          onClose={() => {
            this.setState({ show_newsletter_modal: false })
          }}
        />

        <DocumentiHelperModal
          display={this.state.show_cppb_modal}
          iframeSrc={`${window.location.origin}/privacy-policy/v5?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`}
          modalTitle="Privacy Policy brumbrum"
          onClose={() => {
            this.setState({ show_cppb_modal: false })
          }}
        />

        <DocumentiHelperModal
          display={this.state.show_tdu_modal}
          iframeSrc={`${window.location.origin}/condizioni-utilizzo/v3?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`}
          modalTitle="Termini di Utilizzo brumbrum"
          onClose={() => {
            this.setState({ show_tdu_modal: false })
          }}
        />
      </section>
    )
  }
}

const mapStateToProps = state => ({
  product: state.product,
  privacy: state.privacy,
  customer: state.customer,
  fetching: state.ui.fetching,
  ui: state.ui,
  ordine: state.ordine,
  routing: state.routing,
})

Register.defaultProps = {
  h2: (
    <h2 className={'intro'}>
      Ancora pochi passi e potrai guidare la tua auto: lasciaci i tuoi contatti
      per proseguire con l'acquisto o riprenderlo quando vuoi.
    </h2>
  ),
  next: '/cart',
  idLead: 'registrazione_acquisto',
  showPrenota: false,
  GA_registerEvent: GA_EVENTS.leadSelloutRegister,
}

Register.propTypes = {
  customerUpdate: PropTypes.func,
  privacyUpdate: PropTypes.func,
  reroute: PropTypes.func,
  registrationEmail: PropTypes.func,
  setCodicePreventivo: PropTypes.func,
  registrationLead: PropTypes.func,
  subscribeNewsletter: PropTypes.func,
  phaseChange: PropTypes.func,
  product: PropTypes.object,
  privacy: PropTypes.object,
  customer: PropTypes.object,
  fetching: PropTypes.bool,
  ui: PropTypes.object,
  h2: PropTypes.element,
  h3: PropTypes.element,
  next: PropTypes.string,
  idLead: PropTypes.string,
  showPrenota: PropTypes.bool,
}

const mapDispatchToProps = dispatch => ({
  customerUpdate: payload => dispatch(customerUpdate(payload)),
  privacyUpdate: payload => dispatch(privacyUpdate(payload)),
  reroute: payload => dispatch(reroute(payload)),
  registrationEmail: payload => dispatch(registrationEmail(payload)),
  registrationLead: payload => dispatch(registrationLead(payload)),
  subscribeNewsletter: payload => dispatch(subscribeNewsletter(payload)),
  phaseChange: payload => dispatch(phaseChange(payload)),
  setCodicePreventivo: payload => dispatch(setCodicePreventivo(payload)),
  setIdLead: idLead =>
    dispatch({
      type: REGISTRATION_LEAD,
      payload: { data: { result: { id_evento: idLead } } },
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(Register)
